export function downloadFile(downloadedFileResponse: { data: any }, fileName: string) {
    const url = window.URL.createObjectURL(downloadedFileResponse.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;

    link.dispatchEvent(
        new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: false,
        })
    );
    window.URL.revokeObjectURL(url);
}
